var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main"},[_c('div',{staticClass:"title_text-main txt-main h2",class:[
      _vm.leftDecor ? 'leftDecor' : '',
      _vm.rightDecor ? 'rightDecor' : '' ]},[_vm._v(" "+_vm._s(_vm.textMain)+" ")]),_c('div',{staticClass:"title_text-sub h6 txt-black txt-600"},[_vm._v(_vm._s(_vm.textSub))])])}
var staticRenderFns = []

export { render, staticRenderFns }